import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Button from "../components/Button";
import ReactGA from "react-ga4";
import { ImSpinner9 } from "react-icons/im";
import { apiReportAbuse } from "../services/apiService";

const ReportAbuse = () => {
  const [abuse, setAbuse] = useState({ abuseType: "--" });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const params = useParams();

  const isTracking =
    process.env.REACT_APP_GA_TRACKING === "true" ? true : false;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAbuse((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async () => {
    if (abuse.abuseType === "--") {
      return;
    } else {
      setIsLoading(true);
      setError(false);
      const response = await apiReportAbuse(params.relayId, abuse);
      if (response.hasError) {
        console.log(response.error);
        setIsLoading(false);
        setAbuse({ abuseType: "--" });
        setError(true);
      } else {
        setTimeout(() => {
          setIsDisabled(true);
          setIsLoading(false);
        }, 1000);
      }
    }
  };

  const handleGAEvent = (category, action, label) => {
    if (isTracking) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  };

  return (
    <div className="grid justify-items-center mt-20">
      <div className="text-4xl">Report Abuse</div>
      {isDisabled && (
        <div className="flex justify-center text-2xl text-center px-10 mt-10">
          Thank you for improving the Snappily community!
        </div>
      )}
      {isLoading && (
        <div className="text-4xl text-snappily-orange animate-spin mt-14 mb-14">
          <ImSpinner9 />
        </div>
      )}
      {!isLoading && !isDisabled && (
        <div>
          <form className="grid mt-10">
            <label className="flex justify-center text-xl mb-2">
              Reason for report
            </label>
            <select
              id="abuse-type"
              name="abuseType"
              className="border-1 border-gray-400 rounded-md p-2 ml-5x"
              value={abuse.abuseType}
              onChange={handleChange}
            >
              <option>--</option>
              <option value="spam">Seems like spam</option>
              <option value="scam">Seems like a scam</option>
              <option value="inapropriate">Message is inappropriate</option>
              <option value="illegal">Involves illegal activity</option>
              <option value="annoying">Sender is annoying</option>
            </select>
          </form>
          <div className="flex justify-center mt-5">
            <Button
              background="bg-snappily-orange"
              text="text-white"
              opacity="bg-opacity-100"
              title="Report"
              height="h-10"
              width="w-40"
              borderHover="hover:border-snappily-orange"
              isDisabled={isDisabled}
              customFunc={() => {
                handleSubmit();
                handleGAEvent("Button Click", "Click", "Spam Report Sumbitted");
              }}
            />
          </div>
          {error && (
            <div className="text-red-500 mt-5">
              There was an error. Please try again.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportAbuse;
